import { CancelPolicyRule } from "@graphql/types";
import { Trans } from "@helpers/translate";
import React, { FC } from "react";
import { getCancelPolicyText } from "./utils/getCancelPolicyText";
import { Title } from "@components/ui/Title";
import Icon from "@components/ui/Icon";

interface Props {
  rules: CancelPolicyRule[];
}

export const CancelPolicy: FC<Props> = ({ rules }) => {
  const items = getCancelPolicyText(rules);
  return (
    <div className="mb-20">
      <Title as="h2" size="md" divider>
        <Trans id="tour.block.cancel-policy.title">Cancellation Policy</Trans>
      </Title>

      <ul>
        {items.map((item) => (
          <li key={item.id} className="flex items-center mb-2">
            <Icon
              icon={item.isRefundable ? "checkCircle" : "closeCircle"}
              size="sm"
              className={`mr-2 ${
                item.isRefundable ? "text-green-800" : "text-red-800"
              }`}
            />
            <div>{item.text}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};
